export const Search = Object.freeze({
    InvoiceListing: "search.invoice.listing"
});